module.exports = {
  name: 'DeviceAvatar',
  props: {
    item: {
      type: Object,
      required: true
    },
    select: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    functypeIcon() {
      return this.$FuncTypeIcons[this.item.functype] || this.$FuncTypeIcons['unknown'];
    },
    isBattery() {
      return this.item.battery && this.item.battery <= 100 && this.item.battery > 0;
    }
  },
  template: `
<v-tooltip bottom lazy>
  <v-list-tile-avatar slot="activator">
    <transition name="slide-fade" mode="out-in">
      <img :src="functypeIcon" v-if="!select" key="unselected">
      <v-icon large color="green" v-else key="selected">check_circle</v-icon>
    </transition>
  </v-list-tile-avatar>
  <div>{{ item.name }}</div>
  <div>{{ item.key }}</div>
  <div v-if="item.lastUpdateTimestamp">{{ new Date(item.lastUpdateTimestamp*1000).toLocaleString() }}</div>
  <div v-if="isBattery">{{ $t('device.battery_remain') }}: {{ item.battery }}</div>
</v-tooltip>
  `
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/DeviceAvatar.js
// module id = PHFF
// module chunks = 0